import { render, staticRenderFns } from "./Buy-Get.vue?vue&type=template&id=2b1a131d&"
import script from "./Buy-Get.vue?vue&type=script&lang=js&"
export * from "./Buy-Get.vue?vue&type=script&lang=js&"
import style0 from "./Buy-Get.vue?vue&type=style&index=0&id=2b1a131d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports